module.exports = __webpack_public_path__ + "static/media/icon-user-grey.dcf95452.svg";